/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Email_Task_ClosedInputs */

const en_api_error_task_email_task_closed = /** @type {(inputs: Api_Error_Task_Email_Task_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed tasks cannot send emails.`)
};

const pt_br2_api_error_task_email_task_closed = /** @type {(inputs: Api_Error_Task_Email_Task_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefas encerradas não enviam e-mails.`)
};

/**
* | output |
* | --- |
* | "Closed tasks cannot send emails." |
*
* @param {Api_Error_Task_Email_Task_ClosedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_email_task_closed = /** @type {((inputs?: Api_Error_Task_Email_Task_ClosedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Email_Task_ClosedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_email_task_closed(inputs)
	return pt_br2_api_error_task_email_task_closed(inputs)
});